"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const composeValidators = (...validators) => (value) => validators.reduce((error, validator) => error || validator(value), undefined);
exports.default = composeValidators;
